<template>
<div class="itt-profil-btn">
   <span class="text">{{user}}</span>

  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 1837 459.25" enable-background="new 0 0 1837 459.25" xml:space="preserve">
    <g id="Calque_2">
      <linearGradient id="SVGID_btn_profile_1" gradientUnits="userSpaceOnUse" x1="0" y1="229.625" x2="532.3125" y2="229.625">
        <stop offset="0" style="stop-color:#F00000"/>
        <stop offset="1" style="stop-color:#950000"/>
      </linearGradient>
      <polygon fill="url(#SVGID_btn_profile_1)" points="125.25,0 396.62,0 532.31,240.06 396.62,459.25 125.25,459.25 0,229.62 "/>
        <linearGradient id="SVGID_btn_profile_2" gradientUnits="userSpaceOnUse" x1="503.59" y1="428.6125" x2="1595.0265" y2="34.1643">
          <stop offset="0" style="stop-color:#F00000"/>
          <stop offset="1" style="stop-color:#950000"/>
        </linearGradient>
      <polygon fill="url(#SVGID_btn_profile_2)" points="427.94,459.25 563.62,240.06 417.5,0 1690.88,0 1837,229.62 1690.88,459.25 "/>
    </g>
    <g id="Calque_3">
      <circle fill="#FFFFFF" cx="260.94" cy="177.44" r="41.75"/>
      <path fill="#FFFFFF" d="M167,302.69h187.88c0,0,0-62.62-93.94-62.62S167,302.69,167,302.69z"/>
    </g>
  </svg>
</div>
</template>

<script>
export default {
  props: {
    user: String
  }

}
</script>

<style lang="sass" scoped>
.itt-profil-btn 
  position: relative
  width: 200px
  .text 
    color: white
    position: absolute
    margin-left: 40px
    width: calc(100% - 40px)
    top: 50%
    transform: translateY(-50%)

</style>
